import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { filterAndSortClones } from '../../../js/cloneFilter';
import { convertToByteUnitLabel, isUndefinedNullOrEmpty, formatDate } from '../../../js/utils';
import { imageStatuses } from '../../../js/statuses';
import { deleteImage } from '../../../js/actions/manageModeActionCreators';
import { hasValidLicence } from '../../../js/projections/licence';
import DeleteIcon from '../../../icons/clone-icons_delete.svg';
import ImageStatus from '../ImageStatus';
import NoClones from '../NoClones';
import Popup from '../../common/Popup';
import ImageDeleteConfirmation from '../ImageDeleteConfirmation';
import DisableableLink from '../../common/DisableableLink';

const ImageCard = React.createClass({
    propTypes: {
        image: PropTypes.object.isRequired,
        deleteImage: PropTypes.func.isRequired,
        imageCreationProgress: PropTypes.object, 
        canCreate: PropTypes.bool.isRequired
    },
    getInitialState: function () {
        return {
            showDeleteConfirmation: false
        };
    },
    requestImageDeletion: function (e) {
        this.setState({ showDeleteConfirmation: true });
        e.preventDefault();
    },
    onCancelDeletion: function (e) {
        this.setState({ showDeleteConfirmation: false });
        e.preventDefault();
    },
    onConfirmDeletion: function (e) {
        this.setState({ showDeleteConfirmation: false });
        this.props.deleteImage(this.props.image.id);
        e.preventDefault();
    },
    render: function () {
        const { image, clones, serverName, imageDestinationLocation, databaseName, operation, imageCreationProgress, canCreate } = this.props;
        const { showDeleteConfirmation } = this.state;
        const hasClones = clones.length > 0;
        const operationInProgress = operation && operation.isInProgress();
        const isCreated = !operationInProgress && image.status.state === imageStatuses.created;

        return <div className="pure-u-1-2">
            <div className="pure-u-1-1">
                <div className="dashboard-image-container">
                    <div className="dashboard-image">

                        {showDeleteConfirmation && <ImageDeleteConfirmation clones={clones} onConfirmDeletion={this.onConfirmDeletion} onCancelDeletion={this.onCancelDeletion} />}

                        {!showDeleteConfirmation && <div className="image-sidebar pure-menu pure-u-1-1">
                            <Link to={'/dashboard/images/' + image.id}>
                                <div className="pure-u-1-2">
                                    <h3 className="imageName">{image.name}</h3>
                                </div>
                            </Link>
                            <div className="image-actions pure-u-1-2">
                                {isCreated &&
                                    <DisableableLink to={'/clones/create/source?imageId=' + image.id} className="small primary button--ghost" disabled={!canCreate}>Clone</DisableableLink>}
                                {!operationInProgress &&
                                    <Popup content="Delete image">
                                        <img onClick={this.requestImageDeletion} src={DeleteIcon} className="deleteIcon"></img>
                                    </Popup>}
                            </div>
                            <div className="sidebar-inner">
                                <ul className="pure-menu-list">
                                    {!operationInProgress && <li className="imageSize pure-menu-item">{convertToByteUnitLabel(image.status.sizeInBytes)}</li>}
                                    <li className="pure-menu-item">Created by {image.createdBy}{image.createdDate && ` on ${formatDate(image.createdDate)}`}</li>
                                </ul>
                            </div>
                            <div className="sidebar-inner">
                                <ul className="pure-menu-list">
                                    <li className="serverName pure-menu-item">{serverName}</li>
                                    <li className="databaseName pure-menu-item">{databaseName}</li>
                                    <li className="imageLocation pure-menu-item">{imageDestinationLocation && imageDestinationLocation.uncPath}</li>
                                </ul>
                            </div>
                            <div>
                                {hasClones ?
                                    <div className="pure-u-1-1">
                                        <Link to={'/dashboard/images/' + image.id} className="pure-u-1-2">
                                            <p className="cloneName">Clones ({clones.length})</p>
                                        </Link>
                                    </div> :
                                    <div>
                                        {(operation && operation.isSuccessful()) ?
                                            <NoClones image={image} canCreate={canCreate}/> :
                                            <ImageStatus operation={operation} imageCreationProgress={imageCreationProgress} />}
                                    </div>}
                            </div>
                        </div>}

                    </div>
                </div>
            </div>
        </div>;
    }
});

const mapStateToProps = (state, ownProps) => {
    const { image } = ownProps;
    const { sourceLocationId, imageLocationId, id } = image;
    const clones = filterAndSortClones(state.clones.value.values()).filter(c => c.parentImageId === id);
    const imageDestinationLocation = Array.from(state.imageDestinationLocations.value.values()).find(x => x.id === imageLocationId);
    const sqlServerInstance = Array.from(state.sqlServerInstances.value.values()).find(x => x.id === sourceLocationId);
    const serverName = sqlServerInstance && (sqlServerInstance.server + '\\' + sqlServerInstance.instance);
    let databaseName;

    if (!isUndefinedNullOrEmpty(image.sourceLocationResourceNames) && image.sourceLocationResourceNames.length > 0) {
        databaseName = image && image.sourceLocationResourceNames[0];
    }

    const operation = image.latestOperationId && state.operations.value.get(image.latestOperationId);

    const imageCreationProgress = !isUndefinedNullOrEmpty(operation) ?
        state.operationProgress.value.get(operation.operationId) :
        null;

    return {
        serverName: serverName,
        imageDestinationLocation: imageDestinationLocation,
        clones: clones,
        operation: operation,
        databaseName: databaseName,
        imageCreationProgress: imageCreationProgress,
        canCreate: hasValidLicence(state)
    };
};

const mapDispatchToProps = (dispatch) => ({
    deleteImage: (imageId) => {
        dispatch(deleteImage(imageId));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(ImageCard);



// WEBPACK FOOTER //
// ./src/components/dashboard/DashboardPage/ImageCard.jsx